import MUIStack from "@mui/material/Stack";

const Stack = MUIStack;

export default Stack;
